import styled from 'styled-components'

export const VerticalDivider = styled.div`
  background-color: var(--color-text-ultralight);
  height: 10px;
  width: 1px;
  margin: 0 1px;
`
